// extracted by mini-css-extract-plugin
module.exports = {"root":"IconPlus_root__1aty5","horizontalLine":"IconPlus_horizontalLine__1xas6","verticalLine":"IconPlus_verticalLine__1MUZ7","lineVerticalOpen":"IconPlus_lineVerticalOpen__2eidH"};